import React, {useState, useEffect} from 'react';
import NavBar from '../../../../Component/NavBar'
import SectionHeader from '../../../../Component/Containers/Section-Header'
import FlightSearch from './FlightSearch'
import DaysCarousel from '../../../../Component/DaysCarousel'
import FlightsResult from './Results'
import FlightSummary from './FlightSummary'
import PlaneAnimation from '../../../../Component/PlaneAnimation'
import HelpSection from "../../../Common/HelpSection";
import {useLoginHook} from "../../../../Hooks/useLoginHook";
import { useHistory, useLocation } from 'react-router-dom';
import {post} from '../../../../Model/Config/Axios'
import { showToast } from '../../../../Component/Toast';
import FlightFilters from '../../../../Component/Filters/Flight'
import moment from 'moment'
import ScrollToTop from '../../../../Component/ScrollToTop/ScrollToTop'
import {useEventsHook} from '../../../../Hooks/useEventsHook';

function Index() {

	let EVENTS = useEventsHook();

    let CONFIG = useLoginHook();
	let HISTORY = useHistory();
	if(!CONFIG.authenticated){
		HISTORY.push('/login')
	}

	let {search} = useLocation();
	const Params = new URLSearchParams(search);
	let From = Params.get('from')
	let fCity = Params.get('fcity')
	let To = Params.get('to')
	let tCity = Params.get('tcity')
	let Date = parseInt(Params.get('date'))
	let Adult = parseInt(Params.get('adult'))
	let Child = parseInt(Params.get('child'))
	let Infant = parseInt(Params.get('infant'))
	const [FilterCount, setFilterCount] = useState(0);

	let max = 10;

	//Max Limit
	if(Adult&&Adult>max){
		Adult = 10
	}
	if(Adult&&Child&&(Adult+Child)>max){
		Child = 0
	}
	if(Adult&&Child&&Infant&&(Adult+Child+Infant)>max){
		Infant = 0
	}

	const [Result, setResult] = useState([]);
	const [Filters, setFilters] = useState({stops:undefined, price: undefined, time:undefined, airline: undefined, category: undefined});

	const [Departure, setDeparture] = useState(undefined);

	const [FromAirport, setFromAirport] = useState({code:From, city:fCity});
	const [ToAirport, setToAirport] = useState({code:To, city: tCity});
	const [SelectedDate, setSelectedDate] = useState(Date?parseInt(Date):moment().valueOf());
	const [Passengers, setPassengers] = useState({adult:Adult?Adult:1, child:Child?Child:0, infant:Infant?Infant:0});

	const [SearchFinished, setSearchFinished] = useState(false);
	const [ShowFilters, setShowFilters] = useState(undefined);

	useEffect(() => {
		if(FromAirport.code&&ToAirport.code&&SelectedDate&&Passengers){
			SearchFlights(FromAirport, ToAirport, SelectedDate, Passengers)
			EVENTS.srp({
				origin: FromAirport.code||'BLANK',
				destination: ToAirport.code||'BLANK',
				passengers: Passengers.adult+Passengers.child+Passengers.infant||0,
			})
		}
		// eslint-disable-next-line
	}, [FromAirport, ToAirport, SelectedDate, Passengers]);

	const SearchFlights = (origin, destination, date, count) => {

		setDeparture(undefined)
		setSearchFinished(false)
		setFilterCount(0)
		HISTORY.push(`/flights/main/search?from=${origin.code}&fcity=${origin.city}&to=${destination.code}&tcity=${destination.city}&date=${date}&adult=${Passengers.adult}&child=${Passengers.child}&infant=${Passengers.infant}`)
		post(`flight/domestic/search`, {origin:origin.code, destination: destination.code, date: moment(date).format('DD-MM-YYYY'), count}, (e,r)=>{
			if(r.errors){
				showToast({
                    message: 'Problem in searching, try again'
                })
			}
            if(r){
				setSearchFinished(true)
				setResult(r.results)
				setFilterCount(r.results.length)
            }else if(e){
				setSearchFinished(true)
                showToast({
                    message: 'Problem in searching, try again'
                })
            }
        })
	}

	useEffect(() => {
		setDeparture(undefined)
	}, [Passengers]);

	return (
		<>
			<SectionHeader color={'var(--material-blue)'}>
				<NavBar/>
				<FlightSearch from={FromAirport} to={ToAirport} date={SelectedDate} passengers={Passengers} setFrom={setFromAirport} setTo={setToAirport} setDate={setSelectedDate} setPassengers={setPassengers}/>
			</SectionHeader>
			<PlaneAnimation loading={true} done={SearchFinished}/>
			<div className="container mt-4 d-none d-md-block">
				<DaysCarousel min={SelectedDate} onClick={(date)=>setSelectedDate(date)} selected={SelectedDate}/>
			</div>
			<div className='d-flex justify-content-end align-items-center d-lg-none position-fixed p-2' style={{bottom:'1rem', left:'1rem', zIndex:15}}>
				<div onClick={()=>setShowFilters(true)} className='bg-dark rounded-4 text-small p-2 ps-3 pe-3 d-flex align-items-center text-white'>
					<i className="fa fa-filter text-white me-2"/> Filters
				</div>
			</div>
			<div className="container mt-4 mt-md-5 mb-5">
				<div className="row">
					<div className="col-md-12 col-lg-9">
						<FlightsResult loaded={SearchFinished} filters={Filters} selected={Departure} onSelect={setDeparture} flights={Result} />
					</div>
					<div className='col-md-12 col-lg-3'>
						<div className='scrollbar-hidden' style={{position:'sticky', top:'2rem', height: 'calc(100vh - 20px)', overflowY:'scroll'}}>
							<FlightFilters count={FilterCount} closeFilters={setShowFilters} filters={Filters} onApply={setFilters} showFilters={ShowFilters} flights={Result}/>
						</div>
					</div>
				</div>
			</div>
			<HelpSection/>
			<ScrollToTop/>
			<FlightSummary passengers={Passengers}  selected={Departure} onCancel={()=>setDeparture(undefined)}/>
		</>
	);
}

export default Index;
